export const filtersConstants = {
  FILTER_BY_CATEGORY: "FILTER_BY_CATEGORY",
  FILTER_BY_BRAND: "FILTER_BY_BRAND",
  FILTER_BY_RATING: "FILTER_BY_RATING",
  FILTER_BY_PRICE: "FILTER_BY_PRICE",
  SORT_BY: "SORT_BY",
};
